define('view/controller/booking/BackButtonView',['require','lib/view/LayoutView','lib/view/BookingUrlBuilder'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');

    return LayoutView.extend({

        template: '#back_button_view',
        _stepManager: null,
        _stepsParams: {
            'category': ['category'],
            'location': ['location'],
            'service': ['service'],
            'paid_attributes': ['addons'],
            'provider': ['provider'],
            'datetime': ['date', 'time']
        },

        initialize: function () {
            var timeline = Config.getInstance().getOption('timeline_type');
            var flexibleProviderTimeline = Config.TIMELINE_FLEXIBLE_PROVIDER;

            this._stepManager = this.getOption('stepManager');
            this.listenTo(this._stepManager, 'stepDone', _.bind(function () {
                if (!this.isDestroyed) {
                    this.render();
                }
            }, this));

            if (timeline === flexibleProviderTimeline) {
                this._stepsParams.datetime.unshift('provider')
            }
        },

        serializeData: function () {
            var steps = this._stepManager.getVisibleSteps();
            var currentStep = this._stepManager.getNextStep();
            var stepIndex = _.indexOf(steps, currentStep);

            var step = null;
            do {
                stepIndex--;

                step = null;
                if (stepIndex >= 0) {
                    step = this._stepManager.getStepObject(steps[stepIndex]);
                }
            } while (step && step.isStepSkipped());

            var result = {};

            if (stepIndex >= 0) {
                var builder = BookingUrlBuilder.getInstance();
                var currentParams = builder._getUrlParams();

                var data = {};
                _.each(this._stepsParams, function (params, step) {
                    var index = _.indexOf(steps, step);

                    _.each(params, function (param) {
                        if (index >= stepIndex) {
                            data[param] = false;
                        } else {
                            data[param] = currentParams[param];
                        }
                    });
                });

                result.url = BookingUrlBuilder.getInstance().buildUrl('booking_step', data);
                result.show_button = true;
            } else if (_.indexOf(steps, currentStep) > 0) {
                // if this is not a first step, but all previous are skipped, lead to the very beginning
                result.url = BookingUrlBuilder.getInstance().buildUrl('booking_step', {
                    'category': false,
                    'location': false,
                    'service': false,
                    'count': false,
                    'addons': false,
                    'provider': false,
                    'date': false,
                    'time': false,
                    'wl': false,
                    'r': false
                });
                result.show_button = true;
            }

            return result;
        }

    });

});
